export const environment = {
  production: false,
  apiUrl: 'https://dev-yatty.radwakhallaf.com/api'
};
